export const phoneRegex =
  /(([0-9]*?)([0-9][0-9][0-9]{3})?([0-9][0-9][0-9]{3})([0-9]{4}))\b/;
export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const urlRegex =
  /https?:\/\/w{0,3}\w*?\.(\w*?\.)?\w{2,3}\S*|www\.(\w*?\.)?\w*?\.\w{2,3}\S*|(\w*?\.)?\w*?\.\w{2,3}[/?]\S*/;
